// extracted by mini-css-extract-plugin
export default {"infoBox":"QbiwziaCiAhfMN9D8zJU","idTitleBox":"c1unrnpE5TDvcccrwUFl"};